import React, { useRef, useEffect } from "react";
import { postEndpoint, GetHook, putEndpoint } from "../../../api/api";
import { useParams } from "react-router-dom";
import { SCORECARD_URL, OBJECTIVE_URL } from "../../../api/urls";
import { DropDownOptionsProps, DropDown } from "../../../ui/DropDown";
import { StatusIcon } from "../../../assets/svg/StatusIcon";
import { parseDropdown } from "../../../utils/parseDropdown";
import { Formik, Field } from "formik";
import Form, { InputSection } from "../components/Form";
import { get } from "../../../utils/get";
import Input from "../../../ui/Input";
import { toast } from "react-toastify";
import { ObjectiveSchema } from "../../../utils/validationSchema/ScorecardSchema/ScorecardValidation";
interface Props {
  setHandleSubmit?: any;
  setObjectives?: any;
  objective?: any;
  closeModal?: any;
  scorecard_id?: any;
  perspective_id?: any;
  editData?: any;
}

const AddObjective = ({
  setHandleSubmit,
  scorecard_id,
  closeModal,
  perspective_id,
  setObjectives,
  objective,
  editData,
}: Props) => {
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();
  // const { id } = useParams();
  const { objective_id } = editData;
  const isAddMode = !objective_id;

  const formRef: any = useRef<any>(null);

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, []);

  useEffect(() => {
    if (!isAddMode) {
      const fields = ["objective", "weight", "notes"];

      const newEditData = {
        ...editData,
        objective: {
          value: get(editData, "objective.id"),
          label: get(editData, "objective.name"),
        },
      };

      fields.forEach((field) =>
        formRef.current.setFieldValue(field, newEditData[field], false)
      );
    }
  }, [isAddMode]);

  const handleAddObjectives = (values) => {
    const payload = {
      objective_id: get(values, "objective.value"),
      weight: get(values, "weight"),
      notes: get(values, "notes"),
    };
    createReq(`${SCORECARD_URL}/${scorecard_id}/objective`, payload);
  };
  const { data: objectives } = GetHook(
    `${OBJECTIVE_URL}?perspective_id=${perspective_id}`
  );

  useEffect(() => {
    const { complete, pending, data, error } = createRes;
    if (error) {
      toast.error(get(data, "message"));
    }
    if (!pending && complete && !error) {
      closeModal();
      toast.success("Objective added successfully");
    }
    return () => {};
  }, [createRes]);

  const editObjective = (values) => {
    const payload = {
      weight: get(values, "weight"),
      notes: get(values, "notes"),
    };
    updateReq(
      `${SCORECARD_URL}/${scorecard_id}/objective/${editData.objective_id}`,
      payload
    );
  };

  useEffect(() => {
    const { complete, pending, data, error } = updateRes;
    if (error) {
      toast.error(get(data, "message"));
    }
    if (!pending && complete && !error) {
      toast.success("Objective updated successfully");
      closeModal();
    }
  }, [closeModal, updateRes]);

  const objectivesOptions = parseDropdown(objectives);
  return (
    <Formik
      innerRef={formRef}
      initialValues={{ objective: "", weight: "", notes: "" }}
      validationSchema={ObjectiveSchema}
      onSubmit={
        isAddMode ? (values) => handleAddObjectives(values) : editObjective
      }
    >
      {() => (
        <Form>
          <InputSection>
            <Field
              name="objective"
              placeholder="select objective name"
              dropdownLabel="Objective name"
              component={DropDown}
              isBordered={true}
              options={objectivesOptions}
              width="96%"
            />
          </InputSection>
          <Field
            name="weight"
            label="Weight"
            component={Input}
            isBordered={true}
            placeholder="enter weight"
            width="18em"
          />

          <InputSection>
            <Field
              type="textarea"
              name="notes"
              placeholder="Description"
              label="Objective description"
              component={Input}
            />
          </InputSection>
        </Form>
      )}
    </Formik>
  );
};

export default AddObjective;
